import { Table } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const BARecord = () => {
  const [BARecordList, setBARecordList] = useState([]);
  const [page, setPage] = useState('1');
  const [total, setTotal] = useState(200);
  const [sortType, setSortType] = useState('desc');
  const [pageOption, setPageOption] = useState('10');

  // 取得住戶資料
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get('/ezcon/api/ba/records', {
          headers: {
            authorization: window.localStorage.getItem('feathers-jwt'),
          },
          params: {
            page: page,
            pageSize: pageOption,
            sortType: sortType,
          },
        });

        setBARecordList(data.dataList);
        setTotal(data.totalCount);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [page, sortType, pageOption]);
  const columns = [
    {
      title: '建立時間',
      dataIndex: 'createdTime',
      sorter: true,
      defaultSortOrder: 'descend',
      render: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      title: '群組',
      dataIndex: 'group',
    },
    {
      title: '設備名稱',
      dataIndex: 'deviceName',
    },
    {
      title: '狀態',
      dataIndex: 'status',

      render: (value) =>
        value === 'error' ? (
          <div style={{ color: '#FF0000' }}>{value}</div>
        ) : (
          <div>{value}</div>
        ),
    },
  ];
  return (
    <>
      <Table
        dataSource={BARecordList}
        columns={columns}
        bordered
        onChange={(pagination, filters, sorter) => {
          if (sorter.order === 'descend') {
            setSortType('desc');
          } else {
            setSortType('asc');
          }
        }}
        pagination={{
          current: parseInt(page),
          pageSize: parseInt(pageOption),
          total: total,
          pageSizeOptions: ['10', '20', '50', '100'],
          onChange: (page, pageSize) => {
            setPage((prevPage) => (prevPage === page ? prevPage : page));
            setPageOption((prevPageSize) =>
              prevPageSize === pageSize ? prevPageSize : pageSize
            );
          },
          onShowSizeChange: (current, size) => {
            setPage(1);
            setPageOption(size.toString());
          },
        }}
      />
    </>
  );
};

export default BARecord;
